import { htmlExtractText } from '../extractText/htmlExtractText.js';

export function htmlToTextFilter() {
	'ngInject';
	return htmlExtractText;
}
